{
  const selectorsPopup = document.getElementById('selectorsPopup');
  const selectorsPopupContent = selectorsPopup.querySelector('.selectors-popup');
  const selectorsPopupForm = document.querySelector('.selectors-popup-form');
  const footerSelects = document.querySelectorAll('.js-footer-select');

  const fields = selectorsPopupForm.querySelectorAll('.selectors-popup-form-field');
  const selects = selectorsPopupForm.querySelectorAll('.selectors-popup-form-field .select');
  const values = selectorsPopupForm.querySelectorAll('.selectors-popup-form-field .values span');
  const submit = selectorsPopupForm.querySelector('button[type="button"]');

  const hasVisited = localStorage.getItem('showed_selectots_popup');

  // Replace Values to the current Selected Currency Value in the Footer START
  const currentCurrencySpans = document.querySelectorAll('.current-currency');
  const currencyCode = Currency.currentCurrency;

  const currencySymbols = { USD: '$', EUR: '€', UAH: '₴' };

  currentCurrencySpans.forEach(span => {
    const symbol = currencySymbols[currencyCode];
    span.textContent = symbol ? `${currencyCode} (${symbol})` : currencyCode;
  });
  // Replace Values to the current Selected Currency Value in the Footer END


  // Handling Selectors in the Footer START
  footerSelects.forEach(function (select) {
    const type = select.dataset.type;

    if (type === 'currency') select.value = currencyCode;
  
    select.addEventListener('change', e => {
      const value = e.target.value;

      switch (type) {
        case 'region':
          if (!value.includes(window.location.hostname)) window.location.href = value;
          break;

        case 'currency':
          Currency.convertAll(Currency.currentCurrency, value);
          break;

        case 'language':
          document.querySelector(`.language-switcher [lang="${value}"]`)?.click();
          break;
      }
    })
  })
  // Handling Selectors in the Footer END


  const showPopup = () => {
    selectorsPopup.classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  const hidePopup = () => {
    selectorsPopup.classList.remove('active');
    document.body.style.overflow = 'visible';
  };

  const deactivateSelectors = () => fields.forEach(field => field.classList.remove('active'));
  const toggleFieldActive = el => el.closest('.selectors-popup-form-field')?.classList.toggle('active');

  if (!hasVisited) {
    setTimeout(showPopup, 2000);

    localStorage.setItem('showed_selectots_popup', 'true');
  }

  submit.addEventListener('click', () => {
    let region;
    let currency;
    let language;

    for (const field of fields) {
      const value = field.querySelector('.values')?.dataset.value;
      const fieldType = field.dataset.type;

      if (fieldType === 'region' && value && !value.includes(window.location.hostname)) region = value;
      if (fieldType === 'currency' && value) currency = value;
      if (fieldType === 'language' && value) language = value;
    }

    if (region) {
      window.location.href = region;
      return;
    }

    if (currency && !language) {
      Currency.convertAll(Currency.currentCurrency, currency);
      window.location.reload();
    }

    if (!currency && language) {
      document.querySelector(`.language-switcher [lang="${language}"]`)?.click();
    }

    if (currency && language) {
      Currency.convertAll(Currency.currentCurrency, currency);
      document.querySelector(`.language-switcher [lang="${language}"]`)?.click();
    }

    hidePopup();
  });


  selectorsPopup.addEventListener('click', hidePopup);

  selectorsPopupContent.addEventListener('click', (e) => {
    e.stopPropagation();

    deactivateSelectors();
  });

  fields.forEach(field => field.addEventListener('click', e => e.stopPropagation()));

  values.forEach(value => value.addEventListener('click', function () {
    const field = this.closest('.selectors-popup-form-field');
    const selectSpan = field.querySelector('.select span');

    toggleFieldActive(this);
    this.closest('.values').dataset.value = this.dataset.option;
    selectSpan.textContent = this.textContent;
  }));

  selects.forEach(function (select) {
    select.addEventListener('click', () => {
      deactivateSelectors();

      toggleFieldActive(select);
    })
  })

  document.addEventListener('keydown', e => e.key === 'Escape' && hidePopup());
}